import angular from "angular";
import { configureStates } from "../../core/router/router-helper.provider";
import { PayoutReportRoutingModule } from "./report/payout-report-routing.module";
import { PayoutPolicyRoutingModule } from "./policy/payout-policy-routing.module";

const routes = [{
    state: "payout",
    config: {
        url: "/payout",
        abstract: true
    }
}];

export const PayoutRoutingModule = angular
    .module("apex.mainApp.payout.routing", [
        PayoutReportRoutingModule,
        PayoutPolicyRoutingModule
    ])
    .run(configureStates(routes))
    .name;
